<template>
  <div id="app" style="width: 100%;">
    <el-container>
      <el-header id="systemHeader">
        <el-row>
          <el-col :span="12" style="text-align:left">CommonsenseVIS
            <el-button size="medium" type="text">
              <a href="#post" style="color: white;">
                  What is <span class="whiteTitle">CommonsenseVIS</span>?
              </a>
            </el-button>
          </el-col>
          <el-col :span="12" style="text-align:right">
              <!-- <el-switch
                v-model="filterStopWords"
                active-text="Filter Stop Words"
                inactive-text="" style="padding: 10px;">
              </el-switch> -->
            <el-button plain @click="changeFilterStopWords" size="medium">
              <i v-if="filterStopWords" class="el-icon-success" style="font-size: 18px;"></i> 
              <i v-else class="el-icon-circle-check" style="font-size: 18px;"></i> 
              Filter Stop Words
            </el-button>
            <el-button plain @click="openDrawer" size="medium">
              <i class="el-icon-s-order" style="font-size: 18px;"></i> 
              Model Editing
            </el-button>
            <!-- <el-button plain @click="dialogFormVisible=true">
              <i class="el-icon-setting" style="font-size: 18px;"></i> 
            </el-button> -->
            <span style="padding-left: 20px; padding-right: 20px;" @click="dialogFormVisible=true">
                <a class="header-icon-link">
                  <i class="fas fa-info-circle" aria-hidden="true"></i>
                </a>
            </span>
            <span style="padding-right: 20px;">
                <a class="header-icon-link" target="_blank" href="https://andy-xingbowang.com/papers/commonsense_vis2023.pdf">
                    <i class="fas fa-book" aria-hidden="true"></i>
                </a>
            </span>
            <span style="padding-right: 20px;">
                <a class="header-icon-link" target="_blank" href="https://youtu.be/DVBvKmuZVFI">
                    <i class="fab fa-youtube" aria-hidden="true"></i>
                </a>
            </span>
            <span style="padding-right: 20px;">
              <a class="header-icon-link" href="https://andy-xingbowang.com/commonsenseVIS">
                  <i class="fab fa-github" aria-hidden="true"></i>
              </a>
            </span>
          </el-col>
        </el-row>
      </el-header>
      <el-main id="systemMain">
          <HistoryView/>
          <el-dialog title="CommonsenseVIS" :visible.sync="dialogFormVisible">
            <el-row justify="left" style="text-align:left">
              <el-col :span="8"><span class="viewlabel">Dataset: </span>
                <el-select v-model="selectedDataset" placeholder="Select">
                  <el-option
                    v-for="d in dataset"
                    :key="d"
                    :label="d"
                    :value="d">
                  </el-option>
                </el-select></el-col>
              <el-col :span="8"><span class="viewlabel">Split: </span>
                <el-select v-model="selectedSplit" placeholder="Select">
                    <el-option
                      v-for="s in splits"
                      :key="s"
                      :label="s"
                      :value="s">
                    </el-option>
                </el-select></el-col>
              <el-col :span="8"><span class="viewlabel">Model: </span>
                <el-select v-model="selectedModel" placeholder="Select">
                    <el-option
                      v-for="m in models"
                      :key="m"
                      :label="m"
                      :value="m">
                    </el-option>
                </el-select></el-col>
             </el-row>
             <el-row justify="left" style="text-align:left; padding-top: 20px;">
              <span class="viewlabel">Model Performance </span>
              <span class="viewlabel">71.00%</span>
             </el-row>
             <span slot="footer" class="dialog-footer">
              <!-- <el-button @click="dialogFormVisible = false">Cancel</el-button> -->
              <el-button type="primary" @click="dialogFormVisible = false">OK</el-button>
            </span>
          </el-dialog>
         <el-row>
            <el-col :span="16" style="padding:2px;">
              <el-row>
                <MainView :mainViewData="mainViewData"/>
              </el-row>
              <el-row>
                <SubsetView :mainViewData="mainViewData" :selectedDataset="selectedDataset" 
                  :selectedSplit="selectedSplit" :filterStopWords="filterStopWords"/>
              </el-row>
            </el-col>
            <el-col :span="8" style="padding:2px;">
              <InstanceView :mainViewData="mainViewData" :selectedDataset="selectedDataset" 
                :selectedSplit="selectedSplit" :filterStopWords="filterStopWords"/>
            </el-col>
          </el-row>
          
      </el-main>
    </el-container>
    <el-dialog title="User Study" :visible="userFormVisible">
    <el-form :model="form">
      <el-form-item label="ID" label-width="120px">
        <el-input v-model="form.userid" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Name" label-width="120px">
        <el-input v-model="form.username" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onFormSubmit">Submit</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
/* global d3 $ _ */
import InstanceView from "./components/InstanceView/InstanceView.vue"
import MainView from "./components/MainView/MainView.vue"
import dataService from "./service/dataService.js"
import SubsetView from "./components/SubsetView/SubsetView.vue";
import HistoryView from "./components/HistoryView/HistoryView.vue";
import globalConfig from "./service/globalConfig";
import pipeService from './service/pipeService.js';

export default {
  name: "app",
  components: {
    InstanceView,
    MainView,
    SubsetView,
    HistoryView
},
  data() {
    return {
      dataset: ["csqa1"],
      selectedDataset: "csqa1",
      splits: ["dev"],
      selectedSplit: "dev",
      selectedModel: "UnifiedQA",
      models: ["UnifiedQA"],
      mainViewData: {},
      filterStopWords: false, 
      dialogFormVisible: false,
      userFormVisible: false,
      form: {
          userid: '',
          username: ''
        },
      formLabelWidth: '120px'
    };
  },
  watch: {
  },
  methods: {
    onFormSubmit: function () {
        if(this.form.userid !== "" && this.form.username !== ""){
          this.userFormVisible = false;
          dataService.updateUserInfo(this.form.userid, this.form.username);
      }
    },
    changeFilterStopWords: function() {
      this.filterStopWords = !this.filterStopWords;
    }, 
    openDrawer: function(){
      pipeService.emitOpenDrawer(true);
    }
     
  },
  mounted: function () {
    console.log("d3: ", d3); /* eslint-disable-line */
    console.log("$: ", $); /* eslint-disable-line */
    console.log("this: ", this, this.components);
    console.log(
      "_",
      _.partition([1, 2, 3, 4], (n) => n % 2)
    ); /* eslint-disable-line */
    //*--------------------------------------
    // initialize system data
    //*--------------------------------------
    dataService.intialize(this.selectedDataset, this.selectedSplit, (data)=>{
      console.log("system data", Object.keys(data["0"]));
      this.mainViewData = data;
    })
    
    console.log("disable dialogForm", globalConfig.USERSTUDY_MODE);
    if(globalConfig.USERSTUDY_MODE === true){
      
      this.userFormVisible = true;
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  margin: 0 auto;
}

#systemHeader {
  background-color: #2c3e50;
  color: white;
  /* background-color: white;
  color: black; */
  text-align: start;
  font-weight: bold;
  font-size: 25px;
  line-height: 60px;
}

#systemMain {
  padding: 5px;
  /* background-color: #E9EEF3; */
  color: #333;
  text-align: center;
  height: 92vh;
}

.viewheader {
  font-weight: bold;
  text-align: start;
  padding: 5px;
  background: #e5e9f2;
}

.viewlabel {
  font-weight: bold;
  text-align: start;
  padding: 5px;
}

.viewbody {
  height: 50vh;
}

.row_center{
  text-align: center;
}
.col_solid{
  border:1px solid transparent
}
.col_float{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  /*flex-direction: row;*/
  justify-content: flex-start;
}
</style>
